import React from "react";
import ReactDOM from "react-dom";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "formdata-polyfill";
import baltoStyle from "./scss/index.scss";
import App from "./App";

const target = document.getElementById("baltoRoot");

const head = document.head;

const baltoStyleTag = document.createElement("style");

baltoStyleTag.innerHTML = baltoStyle.toString();

head.appendChild(baltoStyleTag);

ReactDOM.render(<App />, target);
